export const getPrivileges = privileges => ({
  type: 'GET_RRIVILEGES',
  privileges
})

